/**
 * @name Voicerecorder
 * @namespace S3.Voicerecorder
 */
S3.Voicerecorder = function ($, Plyr) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  var NAME = 'voicerecorder';
  var DATA_KEY = 'swr3.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_TOGGLE: '[data-toggle=voicerecorder]'
  };

  var symbolsSvgPath = S3.Util.assetBaseURL + '/assets/images/swr3/symbols.svg?154f183e8bc8a742ec6946c05efdccaa';

  /**
   * API to handle audio recording
   */
  var audioRecorder = {
    /**
     * Stores the recorded audio as Blob objects of audio data as the recording continues
     * @type Blob[]
     */
    audioBlobs: [],
    /* of type Blob[] */

    /**
     * Stores the reference of the MediaRecorder instance that handles the MediaStream when recording starts
     * @type MediaRecorder
     */
    mediaRecorder: null,
    /* of type MediaRecorder */

    /**
     * Stores the reference to the stream currently capturing the audio
     * @type MediaStream
     */
    streamBeingCaptured: null,
    /* of type MediaStream */

    label: null,

    muted: false,

    /**
     * Start recording the audio
     * @returns {Promise} - returns a promise that resolves if audio recording successfully started
     */
    start: function start(onStartCallback) {
      // Feature Detection
      if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
        // Feature is not supported in browser
        // return a custom error
        return Promise.reject(
          new Error(
            'mediaDevices API or getUserMedia method is not supported in this browser.'
          )
        );
      } else {
        // Feature is supported in browser

        // create an audio stream
        return (
          navigator.mediaDevices
            .getUserMedia(
              {
                audio: true
              } /* of type MediaStreamConstraints */
            )
            // returns a promise that resolves to the audio stream
            .then(function (stream /* of type MediaStream */) {
              // save the reference of the stream to be able to stop it when necessary
              audioRecorder.streamBeingCaptured = stream;

              audioRecorder.streamBeingCaptured
                .getTracks() // get all tracks from the stream
                .forEach(function (track /* of type MediaStreamTrack */) {
                  audioRecorder.label = track.label;
                  audioRecorder.muted = track.muted;
                });

              // create a media recorder instance by passing that stream into the MediaRecorder constructor
              audioRecorder.mediaRecorder = new MediaRecorder(
                stream
              );
              /*
               the MediaRecorder interface of the MediaStream Recording
               API provides functionality to easily record media
               */

              // clear previously saved audio Blobs, if any
              audioRecorder.audioBlobs = [];

              // add a `dataavailable` event listener in order to store the audio data Blobs when recording
              audioRecorder.mediaRecorder.addEventListener(
                'dataavailable',
                function (event) {
                  //store audio Blob object
                  audioRecorder.audioBlobs.push(event.data);
                }
              );

              audioRecorder.mediaRecorder.addEventListener(
                'start',
                function (event) {
                  console.debug('Aufnahme gestartet', (Date.now()).toString())

                  if (onStartCallback) {
                    onStartCallback(event); // Call the provided callback
                  }
                }
              )

              // start the recording by calling the start method on the media recorder
              audioRecorder.mediaRecorder.start();
            })
        );

        /*
          errors are not handled in the API because if its handled and the promise is chained, the .then after the catch will be executed
        */
      }
    },
    /**
     * Stop the started audio recording
     * @returns {Promise} - returns a promise that resolves to the audio as a blob file
     */
    stop: function stop() {
      // return a promise that would return the blob or URL of the recording
      return new Promise(function (resolve) {
        // save audio type to pass to set the Blob type
        var mimeType = audioRecorder.mediaRecorder.mimeType;

        // listen to the stop event in order to create & return a single Blob object
        audioRecorder.mediaRecorder.addEventListener('stop', function () {
          // create a single blob object, as we might have gathered a few Blob objects that needs to be joined as one
          var audioBlob = new Blob(audioRecorder.audioBlobs, {
            type: mimeType
          });

          // resolve promise with the single audio blob representing the recorded audio
          resolve(audioBlob);
        });
        audioRecorder.cancel();
      });
    },
    /**
     * Cancel audio recording
     */
    cancel: function cancel() {
      //stop the recording feature
      audioRecorder.mediaRecorder.stop();

      //stop all the tracks on the active stream in order to stop the stream
      audioRecorder.stopStream();

      //reset API properties for next recording
      audioRecorder.resetRecordingProperties();
    },
    /**
     * Stop all the tracks on the active stream in order to stop the stream and remove
     * the red flashing dot showing in the tab
     */
    stopStream: function stopStream() {
      // stopping the capturing request by stopping all the tracks on the active stream
      audioRecorder.streamBeingCaptured
        .getTracks() // get all tracks from the stream
        .forEach(function (track /* of type MediaStreamTrack */) {
          return track.stop();
        }); // stop each one
    },
    /**
     * Reset all the recording properties including the media recorder and stream being captured
     */
    resetRecordingProperties: function resetRecordingProperties() {
      audioRecorder.mediaRecorder = null;
      audioRecorder.streamBeingCaptured = null;
      audioRecorder.label = null;
      audioRecorder.muted = false;

      /*
      No need to remove event listeners attached to mediaRecorder as
      If a DOM element which is removed is reference-free (no references pointing to it), the element itself is picked
      up by the garbage collector as well as any event handlers/listeners associated with it.
      getEventListeners(audioRecorder.mediaRecorder) will return an empty array of events.
      */
    }
  };

  /**
   *
   */
  var Voicerecorder = function () {

    function Voicerecorder(element, config) {
      S3.Util._classCallCheck(this, Voicerecorder);

      var self = this;

      self.element = element;
      self.$element = $(self.element);

      self.$containerTextarea = self.$element.closest('.form-group');

      /**
       * Stores the actual start time when an audio recording begins to take place to ensure elapsed time start time is accurate
       */
      self.audioRecordStartTime;

      /**
       * Stores the maximum recording time in seconds to stop recording once maximum recording has been reached
       */
      self.maximumRecordingTime = (3 * 60);

      /**
       * Stores the reference of the setInterval function that controls the timer in audio recording
       */
      self._elapsedTimeTimer;

      self._render();
      self._bindEvents();
    }

    Voicerecorder.prototype._render = function _render() {
      var self = this;

      self.$containerTextarea.find('label,textarea,input').attr('disabled', 'disabled');
      self.$containerTextarea.hide();

      var panelId = S3.Util.uuid();

      self.$containerVoicerecorder = $(
        '<div class="form-group">' +
          '<div id="voicerecorder" class="voicerecorder-wrapper">' +
            '<nav>' +
              '<button class="btn btn-close" type="button" title="Schließen" aria-controls="voicerecorder">' + S3.Util.svgIcon('close', 'Schließen um Textnachricht zu verfassen') + '</button>' +
            '</nav>' +
            '<p class="label">Deine Sprachnachricht</p>' +
            '<div class="alert alert-danger" id="voicerecorder-not-supported" style="display: none"><p class="h3">Audioaufnahme nicht unterstützt</p><p>Verwende für Sprachnachrichten Browser wie Chrome und Firefox, die Audioaufnahmen unterstützen.</p></div>' +
            '<div class="alert alert-danger" id="voicerecorder-not-enabled" style="display: none"><p class="h3">Zugriff auf dein Mikrofon erlauben</p><p>SWR3.de benötigt ein Mikrofon für Sprachnachrichten. Erlaube den Zugriff in den Einstellungen deines Browsers bzw. Computers.</p></div>' +
            '<button class="btn voicerecorder-start-recording" type="button">' + S3.Util.svgIcon('mic', 'Aufnahme starten') + '<span class="sr-only">Aufnahme starten</span></button>' +
            '<button class="btn voicerecorder-stop-recording" type="button" style="display: none">' + S3.Util.svgIcon('audio-stop', 'Aufnahme stoppen') + '<span class="sr-only">Aufnahme stoppen</span></button>' +
            '<button class="btn voicerecorder-cancel-recording" type="button" style="display: none">' + S3.Util.svgIcon('close', 'Aufnahme abbrechen') + '<span class="sr-only">Aufnahme abbrechen</span></button>' +
            '<button class="btn voicerecorder-delete-recording" type="button" style="display: none">' + S3.Util.svgIcon('trash', 'Aufnahme löschen') + '<span class="sr-only">Aufnahme löschen</span></button>' +
            '<div class="voicerecorder-recording-elapsed-time" style="display: none">' +
              '<span class="voicerecorder-red-recording-dot" aria-hidden="true"></span>' +
              '<span class="voicerecorder-elapsed-time">00:00</span>' +
            '</div>' +
            '<div class="voicerecorder-audiodevice-label small" style="display: none"></div>' +
            '<audio controls class="voicerecorder-audio-element"></audio>' +
            '<input type="file" name="asset" style="display: none" aria-hidden="true">' +
        '</div>' +

        '<div class="panel-group info-box-collapsable-wrapper" id="accordion-' + panelId + '" role="tablist" aria-multiselectable="true">' +
          '<aside class="panel info-box info-box-collapsable" id="panel-' + panelId + '">' +
            '<div class="panel-heading" role="tab" id="heading-' + panelId + '">' +
              '<h2 class="panel-title">' +
                '<button type="button" class="collapsed" data-toggle="collapse" data-target="#collapse-' + panelId + '" aria-expanded="false" aria-controls="collapse-' + panelId + '">' +
                'Wie funktioniert das?' +
                '</button>' +
              '</h2>' +
            '</div>' +
            '<div id="collapse-' + panelId + '" class="panel-collapse collapse" role="tabpanel" aria-labelledby="heading-' + panelId + '">' +
              '<div class="panel-body info-box-content">' +

                '<ul class="list-unstyled">' +
                  '<li><strong>Schritt 1 - Aufnahmetaste ' + S3.Util.svgIcon('mic', 'Aufnahme starten') + ' anklicken oder antippen</strong></li>' +
                  '<li><strong>Schritt 2 - Zugriff auf das Mikrofon zulassen und sprechen</strong><br />' +
                    '<small>Es erscheint ein Pop-up-Fenster, in dem du um Erlaubnis gebeten wirst, dass swr3.de auf dein Mikrofon zugreifen darf. Wähle „Zulassen“, um die Aufnahme zu starten. Du kannst maximal drei Minuten lang sprechen.</small></li>' +
                  '<li><strong>Schritt 3 - Aufnahme stoppen</strong><br />' +
                   '<small>Du stoppst durch Klick auf die Schaltfläche ' + S3.Util.svgIcon('audio-stop', 'Aufnahme stoppen') + '. Bei Erreichen der Höchstdauer stoppt die Aufnahme automatisch.</small></li>' +
                  '<li><strong>Schritt 4 - Wiedergabe der Aufnahme oder neuer Versuch</strong><br />' +
                    '<small>Sobald du die Aufnahme beendet hast, wird ein Audioplayer angezeigt. Drücke die Wiedergabetaste ' + S3.Util.svgIcon('audio-play', 'Abspielen') + ', um deine Aufnahme anzuhören, oder klicke auf die Aufnahmetaste ' + S3.Util.svgIcon('mic', 'Aufnahme starten') + ', um es erneut zu versuchen.</small></li>' +
                  '<li><strong>Schritt 5 - Formular fertig ausfüllen und absenden</strong><br />' +
                    '<small>Wenn du mit deiner Aufnahme zufrieden bist, fülle das Formular vollständig aus und schicke es ab.</small></li>' +
                '</ul>' +

              '</div>' +
            '</div>' +
          '</aside>' +
        '</div>');

      // TODO: UI verbessern
      self.$containerTextarea.after(self.$containerVoicerecorder);

      self.audioElement = self.$containerVoicerecorder.find('audio.voicerecorder-audio-element')[0];
      self.fileInputElement = self.$containerVoicerecorder.find('input[type=file]')[0];

      self._plyr = new Plyr(self.audioElement, {
        type: 'audio',
        controls:
          '<div class="plyr__controls">' +
            '<button class="plyr__controls__item plyr__control" type="button" data-plyr="play" aria-label="Abspielen">' +
              '<svg class="icon--pressed" aria-hidden="true" focusable="false"><use xlink:href="' + symbolsSvgPath + '#audio-pause"></use></svg>' +
              '<svg class="icon--not-pressed" aria-hidden="true" focusable="false"><use xlink:href="' + symbolsSvgPath + '#audio-play"></use></svg>' +
              '<span class="label--pressed plyr__sr-only">Pause</span>' +
              '<span class="label--not-pressed plyr__sr-only">Abspielen</span>' +
            '</button>' +
            '<div class="plyr__controls__item plyr__time--current plyr__time" aria-label="Current time">{currentTime}</div>' +
            '<div class="plyr__controls__item plyr__volume">' +
              '<button type="button" class="plyr__control" data-plyr="mute">' +
                '<svg class="icon--pressed" aria-hidden="true" focusable="false"><use xlink:href="' + symbolsSvgPath + '#audio-volume-0"></use></svg>' +
                '<svg class="icon--not-pressed" aria-hidden="true" focusable="false"><use xlink:href="' + symbolsSvgPath + '#audio-volume-3"></use></svg>' +
                '<span class="label--pressed plyr__sr-only">Stummschaltung aufheben</span' +
                '<span class="label--not-pressed plyr__sr-only">Stummschalten</span>' +
              '</button>' +
              '<input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" role="slider" aria-label="Lautstärke" aria-valuemin="0" aria-valuemax="100" id="plyr-volume-{id}">' +
            '</div>' +
          '</div>',
        resetOnEnd: true,
        invertTime: false,
        storage: false,
        loadSprite: false,
        blankVideo: 'https://www.swr3.de/assets/swr3/blank.mp3',
        i18n: {
          restart: 'Neustart',
          play: 'Abspielen',
          pause: 'Pause',
          currentTime: 'Aktuelle Zeit',
          duration: 'Dauer',
          volume: 'Lautstärke',
          mute: 'Stummschalten',
          unmute: 'Stummschaltung aufheben',
          start: 'Start',
          end: 'Ende',
          all: 'Alle',
          reset: 'Zurücksetzen',
          disabled: 'Deaktiviert',
          enabled: 'Aktiviert',
        },
      });

      self.$startRecordingButton = self.$containerVoicerecorder.find('button.voicerecorder-start-recording');
      self.$stopRecordingButton = self.$containerVoicerecorder.find('button.voicerecorder-stop-recording');
      self.$cancelRecordingButton = self.$containerVoicerecorder.find('button.voicerecorder-cancel-recording');
      self.$deleteRecordingButton = self.$containerVoicerecorder.find('button.voicerecorder-delete-recording');
      self.$elapsedTimeContainer = self.$containerVoicerecorder.find('.voicerecorder-recording-elapsed-time');
      self.$elapsedTimeTag = self.$containerVoicerecorder.find('.voicerecorder-elapsed-time');
      self.$audiodeviceLabelTag = self.$containerVoicerecorder.find('.voicerecorder-audiodevice-label');
      self.$audioPlayerContainer = self.$containerVoicerecorder.find('.plyr');

      self.$stopRecordingButton.hide();
      self.$cancelRecordingButton.hide();
      self.$audiodeviceLabelTag.hide();
      self.$elapsedTimeContainer.hide();
      self.$audioPlayerContainer.hide();
    }

    Voicerecorder.prototype._bindEvents = function _bindEvents() {
      var self = this;

      self.$startRecordingButton.on('click' + EVENT_KEY, function (event) {
        self._startRecording()
      });

      self.$stopRecordingButton.on('click' + EVENT_KEY, function (event) {
        self._stopRecording()
      });

      self.$cancelRecordingButton.on('click' + EVENT_KEY, function (event) {
        self._cancelRecording()
      });

      self.$deleteRecordingButton.on('click' + EVENT_KEY, function (event) {
        self._deleteRecording()
      })

      self.$containerVoicerecorder.on('click' + EVENT_KEY, '.btn-close', function (event) {
        try {
          audioRecorder.cancel();
        } catch (e) {
          /* noop */
        }

        self.$containerVoicerecorder.hide();
        self.$containerVoicerecorder.remove();

        self.$containerTextarea.find('label,textarea,input').attr('disabled', false);
        self.$containerTextarea.show();

        self._plyr.destroy();

        self.dispose();
      })
    }

    /**
     * Starts the audio recording
     */
    Voicerecorder.prototype._startRecording = function _startRecording() {
      var self = this;

      console.debug('Voicerecorder: Recording Audio...');

      // If a previous audio recording is playing, pause it
      var recorderAudioIsPlaying = !self.audioElement.paused;

      // the paused property tells whether the media element is paused or not
      console.debug('Voicerecorder: paused?', !recorderAudioIsPlaying);
      if (recorderAudioIsPlaying) {
        self._plyr.pause();
      }
      self.$audioPlayerContainer.hide();
      self.fileInputElement.files = null;

      var onStartCallbackFn = function (event) {
        // store the recording start time to display the elapsed time according to it
        self._audioRecordStartTime = new Date();

        // TODO: display control buttons to offer the functionality of stop and cancel
        self._handleElapsedRecordingTime();

        self.$audiodeviceLabelTag.html('Mikrofon: ' + audioRecorder.label);

        self.$startRecordingButton.hide();
        self.$deleteRecordingButton.hide();
        self.$stopRecordingButton.show();
        self.$cancelRecordingButton.show();
        self.$audiodeviceLabelTag.show();
        self.$elapsedTimeContainer.show();

        // TODO: remove loader für Button
        self.$startRecordingButton.removeClass('loading');
        self.$startRecordingButton.removeAttr('disabled');
      }

      //start recording using the audio recording API
      audioRecorder.start(onStartCallbackFn)
        .then(function () { //on success
          console.debug('Aufnahme angefordert', (Date.now()).toString())
          // TODO: loader für Button
          self.$startRecordingButton.addClass('loading');
          self.$startRecordingButton.attr('disabled', 'disabled');
        })
        .catch(function (error) { //on error
          //No Browser Support Error
          if (error.message.includes('mediaDevices API or getUserMedia method is not supported in this browser.')) {
            console.debug('Voicerecorder: To record audio, use browsers like Chrome and Firefox.');
            // TODO:
            //self._displayBrowserNotSupportedOverlay();
            self.$containerVoicerecorder.find('#voicerecorder-not-supported').show()
          }

          //Error handling structure
          switch (error.name) {
            case 'AbortError': // error from navigator.mediaDevices.getUserMedia
              console.error('Voicerecorder: An AbortError has occurred.');
              break;
            case 'NotAllowedError': // error from navigator.mediaDevices.getUserMedia
              console.error('Voicerecorder: A NotAllowedError has occurred. User might have denied permission.');
              break;
            case 'NotFoundError': // error from navigator.mediaDevices.getUserMedia
              console.error('Voicerecorder: A NotFoundError has occurred.');
              break;
            case 'NotReadableError': // error from navigator.mediaDevices.getUserMedia
              console.error('Voicerecorder: A NotReadableError has occurred.');
              break;
            case 'SecurityError': // error from navigator.mediaDevices.getUserMedia or from the MediaRecorder.start
              console.error('Voicerecorder: A SecurityError has occurred.');
              break;
            case 'TypeError': // error from navigator.mediaDevices.getUserMedia
              console.error('Voicerecorder: A TypeError has occurred.');
              break;
            case 'InvalidStateError': // error from the MediaRecorder.start
              console.error('Voicerecorder: An InvalidStateError has occurred.');
              break;
            case 'UnknownError': // error from the MediaRecorder.start
              console.error('Voicerecorder: An UnknownError has occurred.');
              break;
            default:
              console.error('Voicerecorder: An error occurred with the error name ' + error.name);
          }
          self.$containerVoicerecorder.find('#voicerecorder-not-enabled').show()
        });

      // TODO: Fehlerhinweis ausgeben

      // TODO: remove loader für Button
      self.$startRecordingButton.removeClass('loading');
      self.$startRecordingButton.removeAttr('disabled');
    }

    /**
     * Stop the currently started audio recording
     */
    Voicerecorder.prototype._stopRecording = function _stopRecording() {
      var self = this;

      console.debug('Voicerecorder: Stopping Audio Recording...');

      // stop the recording using the audio recording API
      audioRecorder.stop()
        .then(function (audioAsblob) {
          // TODO: Play recorder audio
          self._playAudio(audioAsblob);

          // TODO: hide recording control button & return record icon
          //handleHidingRecordingControlButtons();
          self.$startRecordingButton.show();
          self.$stopRecordingButton.hide();
          self.$cancelRecordingButton.hide();
          self.$audiodeviceLabelTag.hide();
          self.$elapsedTimeContainer.hide();
          self.$deleteRecordingButton.show();

          // stop interval that handles both time elapsed and the red dot
          if (self._elapsedTimeTimer) {
            clearInterval(self._elapsedTimeTimer);
          }
        })
        .catch(function (error) {
          //Error handling structure
          switch (error.name) {
            case 'InvalidStateError': //error from the MediaRecorder.stop
              console.error('Voicerecorder: An InvalidStateError has occurred.');
              break;
            default:
              console.error('Voicerecorder: An error occurred with the error name ' + error.name);
          }
        });
    }

    /**
     * Cancel the currently started audio recording
     */
    Voicerecorder.prototype._cancelRecording = function _cancelRecording() {
      var self = this;

      console.debug('Voicerecorder: Canceling audio...');

      // cancel the recording using the audio recording API
      try {
        audioRecorder.cancel();
      } catch (e) {
        /* noop */
      }

      // TODO: hide recording control button & return record icon
      //handleHidingRecordingControlButtons();

      self.$startRecordingButton.show();
      self.$stopRecordingButton.hide();
      self.$cancelRecordingButton.hide();
      self.$audiodeviceLabelTag.hide();
      self.$elapsedTimeContainer.hide();
      self.$deleteRecordingButton.hide();

      if (self._elapsedTimeTimer) {
        clearInterval(self._elapsedTimeTimer);
      }
    }

    Voicerecorder.prototype._deleteRecording = function _deleteRecording() {
      var self = this;

      self._plyr.stop();

      self.fileInputElement.files = null;

      self.$audioPlayerContainer.hide();
      self.$deleteRecordingButton.hide();
    }

    /**
     * Plays recorded audio using the audio element in the HTML document
     *
     * @param {Blob} recorderAudioAsBlob - recorded audio as a Blob Object
     */
    Voicerecorder.prototype._playAudio = function _playAudio(recorderAudioAsBlob) {
      var self = this;

      // read content of files (Blobs) asynchronously
      var reader = new FileReader();

      // once content has been read
      reader.onload = function (e) {
        // store the base64 URL that represents the URL of the recording audio
        var base64URL = e.target.result;

        // set the type of the audio element based on the recorded audio's Blob type
        var BlobType = recorderAudioAsBlob.type.includes(';')
          ? recorderAudioAsBlob.type.substr(
            0,
            recorderAudioAsBlob.type.indexOf(';')
          )
          : recorderAudioAsBlob.type;

        self._plyr.source = {
          type: 'audio',
          sources: [{
            src: base64URL,
            type: BlobType
          }]
        }

        // play the audio after successfully setting new src and type that corresponds to the recorded audio
        //console.debug('Voicerecorder: Playing audio...');
        //self._plyr.play()

        // Filename
        var name = new Date();
        var filename = 'sprachnachricht-' + name.toISOString().slice(0, 10);

        // Extension
        switch (BlobType) {
          case 'audio/ogg':
            filename += '.ogg';
            break;
          case 'audio/webm':
            filename += '.webm';
            break;
          default:
            filename += '.wav';
            break;
        }

        // Create a new File object
        var voiceMessageFile = new File([recorderAudioAsBlob], filename, {
          type: BlobType,
          lastModified: new Date()
        });

        // Now let's create a DataTransfer to get a FileList
        var dataTransfer = new DataTransfer();
        dataTransfer.items.add(voiceMessageFile);

        console.debug('Voicerecorder: dataTransfer.files', dataTransfer.files);

        var fileList = dataTransfer.files;
        self.fileInputElement.files = fileList;

        // Display text indicator of having the audio play in the background
        self.$audioPlayerContainer.show();
      };

      // read content and convert it to a URL (base64)
      reader.readAsDataURL(recorderAudioAsBlob);
    }

    /** Computes the elapsed recording time since the moment the function is called in the format h:m:s*/
    Voicerecorder.prototype._handleElapsedRecordingTime = function _handleElapsedRecordingTime() {
      var self = this

      // display initial time when recording begins
      self._displayElapsedTimeDuringAudioRecording('00:00');

      // create an interval that compute & displays elapsed time, as well as, animate red dot - every second
      self._elapsedTimeTimer = setInterval(function () {
        // compute the elapsed time every second
        var elapsedTime = self._computeElapsedTime(); // pass the actual record start time
        // display the elapsed time
        self._displayElapsedTimeDuringAudioRecording(elapsedTime);
      }, 1000); // every second
    }

    /** Display elapsed time during audio recording
     * @param {String} elapsedTime - elapsed time in the format mm:ss or hh:mm:ss
     */
    Voicerecorder.prototype._displayElapsedTimeDuringAudioRecording = function _displayElapsedTimeDuringAudioRecording(elapsedTime) {
      var self = this;

      //1. display the passed elapsed time as the elapsed time in the elapsedTime HTML element
      self.$elapsedTimeTag.html(elapsedTime);
    }

    /** Computes the elapsedTime since the moment the function is called in the format mm:ss or hh:mm:ss
     * @returns {String} elapsed time in mm:ss format or hh:mm:ss format, if elapsed hours are 0.
     */
    Voicerecorder.prototype._computeElapsedTime = function _computeElapsedTime() {
      var self = this;

      // record end time
      var endTime = new Date();

      // time difference in ms
      var timeDiff = endTime - self._audioRecordStartTime;

      // convert time difference from ms to seconds
      timeDiff = timeDiff / 1000;

      if (timeDiff >= self.maximumRecordingTime) {
        if (self._elapsedTimeTimer) {
          clearInterval(self._elapsedTimeTimer);
        }

        self._stopRecording();
      }

      // extract integer seconds that don't form a minute using %
      var seconds = Math.floor(timeDiff % 60); // ignoring incomplete seconds (floor)

      // pad seconds with a zero if necessary
      seconds = seconds < 10 ? "0" + seconds : seconds;

      // convert time difference from seconds to minutes using %
      timeDiff = Math.floor(timeDiff / 60);

      // extract integer minutes that don't form an hour using %
      var minutes = timeDiff % 60; // no need to floor possible incomplete minutes, because they've been handled as seconds
      minutes = minutes < 10 ? "0" + minutes : minutes;

      // convert time difference from minutes to hours
      timeDiff = Math.floor(timeDiff / 60);

      // extract integer hours that don't form a day using %
      var hours = timeDiff % 24; // no need to floor possible incomplete hours, because they've been handled as seconds

      // convert time difference from hours to days
      timeDiff = Math.floor(timeDiff / 24);

      // the rest of timeDiff is number of days
      var days = timeDiff; //add days to hours

      var totalHours = hours + (days * 24);
      totalHours = totalHours < 10 ? "0" + totalHours : totalHours;

      if (totalHours === "00") {
        return minutes + ":" + seconds;
      } else {
        return totalHours + ":" + minutes + ":" + seconds;
      }
    }

    // public
    Voicerecorder.prototype.dispose = function dispose() {
      var self = this;

      try {
        audioRecorder.cancel();
      } catch (e) {
        /* noop */
      }

      self.$element.off(EVENT_KEY);

      if (self._elapsedTimeTimer) {
        clearInterval(self._elapsedTimeTimer);
      }

      self.$containerVoicerecorder.hide();

      self.$containerTextarea.find('label,textarea,input').attr('disabled', false);
      self.$containerTextarea.show();

      self._plyr.stop();
      self.fileInputElement.files = null;

      self._plyr.destroy();

      self.$containerVoicerecorder.remove();

      self.$startRecordingButton = null;
      self.$stopRecordingButton = null;
      self.$cancelRecordingButton = null;
      self.$deleteRecordingButton = null;
      self.$elapsedTimeContainer = null;
      self.$elapsedTimeTag = null;
      self.$audioPlayerContainer = null;
      self.$containerVoicerecorder = null;
      self.$containerTextarea = null;

      $.removeData(self.element, DATA_KEY);

      self.$element = null;
      self.element = null;

      //$(document).off(EVENT_KEY);
    };

    /**
     * @static
     */
    Voicerecorder._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $element = $(this);
        var data = $element.data(DATA_KEY);
        var _config = (typeof config === 'undefined' ? 'undefined' : S3.Util._typeof(config)) === 'object' ? config : null;

        if (!data) {
          data = new Voicerecorder(this, _config);
          $element.data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config]();
        }
      });
    };

    return Voicerecorder;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
    event.preventDefault();
    event.stopPropagation();

    var $trigger = $(this);

    if (!$trigger.has(Selector.DATA_TOGGLE)) {
      $trigger = $trigger.closest(Selector.DATA_TOGGLE);
    }

    Voicerecorder._jQueryInterface.call($trigger, $trigger.data());
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Voicerecorder._jQueryInterface;
  $.fn[NAME].Constructor = Voicerecorder;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Voicerecorder._jQueryInterface;
  };

  return Voicerecorder;

}(window.jQuery, window.Plyr);
